import React from 'react';
import { get_filtered_shoutouts, show_codecommit_stats, get_tvmode_queue, leave_pick_winner_mode,
  update_queue, pick_winner, pop_from_alert_queue, add_to_alert_queue, add_to_new_shoutouts, pop_from_new_shoutouts,
  modal_next, modal_back, time_frame_tv_filter_toggled, recipient_tv_filter_toggled, code_input_changed, display_type_changed,
  set_time_frame_range, set_selected_users, clear_modal, connect_to_tv

} from './types';
import { getShoutoutsBefore } from './ShoutoutsActions';
import { fetchWithTokenRefresh } from './AuthActions';
import TVAlertSlide from '../screens/tv/TVAlertSlide';
import TVSlide from '../screens/tv/TVSlide';
import env from '../globals/environment';

const ROTATION_INTERVAL = 10000;

// export const getFilteredShoutouts = (shoutouts, users, timeFrame) => {
//   return { type: get_filtered_shoutouts, payload: { shoutouts, users, timeFrame } };
// };
export const getFilteredShoutouts = (users, timeFrame) => {
  return async (dispatch, getState) => {
    await dispatch(getShoutoutsBefore(getTVDates(timeFrame).toISOString()));
    dispatch({ type: get_filtered_shoutouts, payload: { shoutouts: getState().shoutoutsStore.tvShoutouts, users, timeFrame } });
  };
};

export const showCodeCommitStats = (show) => {
  return { type: show_codecommit_stats, payload: show };
};

export const getTVDates = (timeFrameRange) => {
  let time;
  switch (timeFrameRange || 'all') {
    case 'today':
      time = new Date(Date.now() - (24 * 60 * 60 * 1000));
      break;

    case 'week':
      time = new Date(Date.now() - (5 * 24 * 60 * 60 * 1000));
      break;

    case 'month':
      time = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000));
      break;

    case 'all':
      time = new Date(1536175475481);
      break;

    default:
      break;
  }
  return time;
};

export const getTVModeQueue = () => {
  return async (dispatch, getState) => {
    const { tvModeStore, shoutoutsStore } = getState();
    const { filteredShoutouts, timeFrame, users } = tvModeStore;
    const { tvShoutouts } = shoutoutsStore;
    let foundShoutouts;
    try {
      // if no shoutouts, get them
      if (!tvShoutouts || !tvShoutouts.length) {
        let date = new Date(getTVDates(getState().tvModeStore.timeFrame));
        await dispatch(getShoutoutsBefore(date.toISOString()));
        foundShoutouts = getState().shoutoutsStore.tvShoutouts;
      } else {
        foundShoutouts = tvShoutouts;
      }

      // if TVMode hasn't filtered its shoutouts
      if (!filteredShoutouts || !filteredShoutouts.length) {
        let tvModeUsers = users && users.length ? users : [];
        dispatch({ type: get_filtered_shoutouts, payload: { shoutouts: foundShoutouts, users: tvModeUsers, timeFrame } });
      }
      dispatch({ type: get_tvmode_queue });

    } catch (error) {
      console.log(error);
    }
  };
};

export const updateQueue = (direction) => {
  return { type: update_queue, payload: direction };
};

export const pickWinner = () => {
  return async (dispatch, getState) => {
    try {
      const { filteredShoutouts, newShoutouts } = getState().tvModeStore;
      const words = ['Nice', 'Great', 'Good job', 'Awesome', 'Sweet'];
      const winnerShoutout = filteredShoutouts[Math.floor(Math.random() * filteredShoutouts.length)];
      const randWord = words[Math.floor(Math.random() * words.length)];
      const randWinner = winnerShoutout.recipients[Math.floor(Math.random() * winnerShoutout.recipients.length)].name;

      const newShoutout = {
        ...winnerShoutout,
        message: `${randWord}! ${randWinner}, you are the winner!`,
        winner: true
      };
      dispatch({ type: pick_winner, payload: newShoutout });
      // if no new shoutouts, TVAlertSlide should not exist
      if (!newShoutouts || !newShoutouts.length) {
        let alertSlide = <TVAlertSlide duration={ROTATION_INTERVAL * 2}/>;
        dispatch({ type: add_to_alert_queue, payload: alertSlide });
      }

    } catch (error) {
      console.log(error);
    }
  };
};

export const addToNewShoutouts = (shoutout) => {
  return async (dispatch, getState) => {
    try {
      const { newShoutouts, queue, users } = getState().tvModeStore;

      if (users && users.length) {
        let userIsRecipient = false;
        let ids = users.map((user) => user._id);
        shoutout.recipients.forEach((recipient) => {
          if (ids.indexOf(recipient._id) !== -1) userIsRecipient = true;
        });

        if (!userIsRecipient) return;
        console.log('user is featured');
      }

      if (!newShoutouts || !newShoutouts.length) {
        let alertSlide = <TVAlertSlide duration={ROTATION_INTERVAL * 2}/>;
        dispatch({ type: add_to_alert_queue, payload: alertSlide });
      }
      let shoutoutSlide = <TVSlide key={queue.length} index={queue.length} shoutout={shoutout}/>;
      dispatch({ type: add_to_new_shoutouts, payload: { shoutout, shoutoutSlide } });

    } catch (error) {
      console.log(error);
    }
  };
};

export const popFromNewShoutouts = () => {
  return { type: pop_from_new_shoutouts };
};

export const popFromAlertQueue = () => {
  return { type: pop_from_alert_queue };
};

export const leavePickWinnerMode = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: leave_pick_winner_mode });
      dispatch({ type: pop_from_new_shoutouts });
    } catch (error) {
      console.log(error);
    }
  };
};

export const clearModal = () => {
  return { type: clear_modal };
};

export const modalNext = () => {
  return { type: modal_next };
};

export const modalBack = () => {
  return { type: modal_back };
};

export const toggleTimeFrameTvFilter = () => {
  return { type: time_frame_tv_filter_toggled };
};

export const toggleRecipientTvFilter = () => {
  return { type: recipient_tv_filter_toggled };
};

export const setTimeFrameRange = (range) => {
  return { type: set_time_frame_range, payload: range };
};

export const setSelectedUsers = (users) => {
  return { type: set_selected_users, payload: users };
};

export const codeInputChanged = (text) => {
  return { type: code_input_changed, payload: text };
};

export const displayTypeChanged = (value) => {
  return { type: display_type_changed, payload: value };
};

export const startAppleTVMode = () => {
  return async (dispatch, getState) => {
    try {
      const { headers } = getState().authStore;
      const testCode = getState().tvModeStore.codeText;
      const tvCode = testCode.toLowerCase();
      const timeFrame = new Date(getTVDates(getState().tvModeStore.timeFrame));
      const tvUsers = getState().tvModeStore.users;
      const userids = tvUsers.map((recipients)=>{
        return recipients._id;
      });
      let response;
      if (getState().tvModeStore.recipientSelected){
        response = await dispatch(fetchWithTokenRefresh(`${env.backendUrl}/tv-sessions/${tvCode}`, {
          method: 'PUT',
          body: JSON.stringify({ timeFrame: timeFrame.toISOString(), recipients: userids }),
          headers
        }));
      } else {
        response = await dispatch(fetchWithTokenRefresh(`${env.backendUrl}/tv-sessions/${tvCode}`, {
          method: 'PUT',
          body: JSON.stringify({ timeFrame: timeFrame.toISOString() }),
          headers
        }));
      }
      if (!response.ok) {
        dispatch({ type: connect_to_tv, payload: 'fail' });
        throw new Error('Could not connect to Apple TV');
      }
      else {
        dispatch({ type: connect_to_tv, payload: 'success' });
        const json = await response.json();
        console.log(json);
      }
      // const response = await dispatch(fetchWithTokenRefresh(`${env.backendUrl}/tv-sessions/${tvCode}`, {
      //   method: 'PUT',
      //   body: JSON.stringify({ timeFrame: timeFrame.toISOString(), forUser: tvUsers[0].uid }),
      //   headers
      // }));
    } catch (error) {
      console.log(error);
    }
  };
};


// WEBPACK FOOTER //
// ./src/actions/TVModeAction.js